import React, { useMemo, useCallback } from 'react';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';
import { useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import { Row, Col, Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';

import PickupSessionApi from '../PickupSessionApi';

import PickupSessionCreateEditForm from './PickupSessionCreateEditForm';
import PickupSessionEditSessionVideo from './PickupSessionEditSessionVideo';

const PickupSessionSingleEdit: React.FC<any> = (props: any) => {

    const app = useApp();

    const { data } = props;

    const form = useForm(data);

    const update = PickupSessionApi.update(data.id, "update", {
        onComplete: (data) => {

            app.alert('Pickup Session Saved', 'success');

        }
    });

    const handleSubmit = useCallback((values) => {

        update.run({ data: values });

    }, [props]);

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <PickupSessionCreateEditForm
                    mode={"edit"}
                    form={form}
                    data={data}
                    handleSubmit={handleSubmit}
                    process={update}
                />

                <Space />

                <PickupSessionEditSessionVideo
                    data={data}
                />


            </Col>

        </Row>

    ), [data, form, update]);

}

export default PickupSessionSingleEdit;
